let receiver = [];
let messengerEvent = null;

export const init = () => {
  receiver = [];
  messengerEvent = null;
  window.addEventListener('message', onReceiveMessage, false);
};

export const remove = () => {
  window.removeEventListener('message', onReceiveMessage);
};

export const addOnReceiveMessage = (message, execFunction) => {
  receiver.push({
    message: message,
    execFunction: execFunction,
  });
};

const onReceiveMessage = (event) => {
  try {
    JSON.parse(event.data);
    const _receivedData = JSON.parse(event.data) || {};
    const _message = _receivedData.message || {};
    const _param = _receivedData.param || {};
    if (!messengerEvent) messengerEvent = event;
    executeMessage(_message, _param);
  } catch (e) {
    //console.error('[onReceiveMessage] message received does not have a valid format and will not be executed.', event.data, e);
  }
};

const executeMessage = (message, param) => {
  // find in receiver
  const theMessage =
    receiver.filter((receiver) => receiver.message === message) || [];
  if (theMessage && theMessage[0] && theMessage[0].execFunction)
    theMessage[0].execFunction(param);
};

export const sendMessage = (message, param, sourceWindow) => {
  const _data = { message: message, param: param };

  if (sourceWindow) {
    sourceWindow.postMessage(JSON.stringify(_data), '*');
  } else if (messengerEvent && messengerEvent.source) {
    messengerEvent.source.postMessage(
      JSON.stringify(_data),
      messengerEvent.origin
    );
  } else {
    console.warn(
      '[sendMessage] cannot postMessage: window does not exists in this context'
    );
  }
};
